import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { DateTimeString, IApiResponse, Locations, Performance } from 'county-api';
import keyBy from 'lodash/keyBy';
import moment, { Moment } from 'moment';
import { Subject, zip as observableZip } from 'rxjs';
import { mergeMap, startWith, tap } from 'rxjs/operators';
import { LocationsState } from '../../../../../locations/store/locations.state';
import { PerformanceDataService } from '../../../../perfomance/performance-data.service';
import {
    IRevenueDialogResult,
    RevenueDialogResultType,
} from '../revenue-dialog.component';

@Component({
    selector: 'revenue-dialog-targets',
    templateUrl: './revenue-dialog-targets.component.html',
    styleUrls: ['./revenue-dialog-targets.component.scss'],
})
export class RevenueDialogTargetsComponent implements OnInit, OnDestroy {
    @Output()
    dialogChangeStep = new EventEmitter<number>();

    @Output()
    dialogSubmit = new EventEmitter<IRevenueDialogResult>();

    private _lastUploadDate: Moment;

    // @Input()
    // set lastUploadDate(date: Moment) {
    //     this._lastUploadDate = date;
    //     this.currentDate$.next(date.clone().startOf('month'));
    // }

    // get lastUploadDate() {
    //     return this._lastUploadDate;
    // }

    currentDate$ = new Subject<Moment>();

    currentDate: Moment;

    loading = 0;

    performanceTargets: Performance.IPerformanceTarget[];

    goodMultiplier = 0;
    greatMultiplier = 0;

    constructor(
        private performanceDataService: PerformanceDataService,
        private store: Store,
    ) {}

    ngOnInit() {
        this.currentDate$
            .pipe(
                startWith(moment().startOf('month')),
                tap(date => {
                    this.loading++;
                    this.currentDate = date;
                }),
                mergeMap(currentDate =>
                    observableZip(
                        this.performanceDataService.getPerformanceTarget(
                            currentDate.format('YYYY-MM'),
                        ),
                        this.store.select(LocationsState.locations),
                    ),
                ),
            )
            .subscribe(data => {
                this.formatTargetData(data);
                this.loading--;
            });

        this.currentDate$.next(moment());
    }

    changeStep(step: number) {
        this.dialogChangeStep.emit(step);
    }

    formatTargetData(
        data: [
            IApiResponse<Performance.IPerformanceTargetsViewModel>,
            Locations.ILocation[],
        ],
    ) {
        this.goodMultiplier = data[0].result.good_multiplier;
        this.greatMultiplier = data[0].result.great_multiplier;

        console.log(this.goodMultiplier);
        console.log(this.greatMultiplier);

        const targets = keyBy(data[0].result.targets, 'location_id');
        const performanceTargets: Performance.IPerformanceTarget[] = [];
        const targetLength = data[1] ? data[1].length : 0;
        for (let l = 0; l < targetLength; l++) {
            const location = data[1][l];
            const target = targets[location.id];

            performanceTargets.push(
                (target
                    ? {
                          amount: target.amount,
                          orbit_amount: 0,
                          location_id: location.id,
                          good_target: this.getGoodTarget(target),
                          great_target: this.getGreatTarget(target)
                      }
                    : {
                          amount: null,
                          orbit_amount: null,
                          location_id: location.id,
                          good_target: 0,
                          great_target: 0
                      }) as Performance.IPerformanceTarget,
            );
        }

        this.performanceTargets = performanceTargets;
    }

    monthClick(offset: number) {
        this.currentDate$.next(this.currentDate.clone().add(offset, 'month'));
    }

    getGoodTarget(target: Performance.IPerformanceTarget){
        if (target.good_target > 0){
            return target.good_target;
        }

        return this.getGoodTargetMultiplier(target.amount);
    }

    getGreatTarget(target: Performance.IPerformanceTarget){
        if (target.great_target > 0){
            return target.great_target;
        }

        return this.getGreatTargetMultiplier(target.amount);
    }

    getGoodTargetMultiplier(target: number){
        return this.goodMultiplier * target;
    }

    getGreatTargetMultiplier(target: number){
        return this.greatMultiplier * target;
    }

    targetAmountChanged(target: Performance.IPerformanceTarget){
        target.good_target = this.getGoodTargetMultiplier(target.amount);
        target.great_target = this.getGreatTargetMultiplier(target.amount);
    }

    submit() {
        this.dialogSubmit.emit({
            type: RevenueDialogResultType.Targets,
            targets: this.performanceTargets,
            date: this.currentDate,
        });
    }

    ngOnDestroy() {
        this.currentDate$.complete();
    }
}
